import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import LeadDialog from './LeadDialog';
import { StyledLeadContainer } from './Styled';
import TextFiledWithLabel from './TextFieldWithLabel';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { buildActivityHeader } from '../Utility/constant';

const AddActionableNoteDialog = ({
    open,
    handleClose,
    handleSave,
    title,
    btnLabel,
    latestRecord,
    latestRecordTitle,
    latestNoteLabel,
    latestDateLabel,
    newRecordTitle,
    newNoteLabel,
    newNoteName,
    newNoteValue,
    newDateLabel,
    newDateName,
    newDateValue,
    handleOnChange,
    noteError,
    readOnly
}) => {
    const header = useMemo(() => {
        if (!latestRecord || !latestRecord.activityType) return null;
        return buildActivityHeader(
            latestRecord.activityType, 
            latestRecord.recipients, 
            latestRecord.createdAt, 
            latestRecord.callStatus, 
            latestRecord.callDuration
        );
    }, [latestRecord]);

    return (
        <LeadDialog
            open={open}
            handleClose={handleClose}
            title={title}
            size="md"
            btnlabel={readOnly ? "Close" : btnLabel}
            handleSave={readOnly ? handleClose : handleSave}
            btnSize={readOnly ? "small" : "medium"}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {latestRecord && (
                    <Box sx={{ backgroundColor: '#f9f9f9', p: 1.5, borderRadius: 1, border: '1px solid #eee' }}>
                        <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 1, display: 'block' }}>
                            {latestRecordTitle}
                        </Typography>
                             {header && (
                                    <Typography variant="body2" sx={{ mb: 1, ml: 0.5, lineHeight: 1.6, fontWeight: 700, color: 'text.primary' }}>
                                        {header.label}
                                        {header.recipientStr && (<>&nbsp;&nbsp;{header.directionLabel}: {header.recipientStr}</>)}
                                        {header.timeStr && (<>,&nbsp;&nbsp;Time: {header.timeStr}</>)}
                                        {header.callStatus && (<>,&nbsp;&nbsp;Status: {header.callStatus}</>)}
                                        {header.callDurationStr && (<>,&nbsp;&nbsp;Duration: {header.callDurationStr}</>)}
                                    </Typography>
                                )}
                        <StyledLeadContainer>
                            <Box sx={{ width: '59%', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                           
                                <Typography variant="caption" sx={{ color: 'text.secondary', ml: 0.5 }}>
                                    {latestNoteLabel}
                                </Typography>
                                <Box
                                    sx={{
                                        border: '1px solid rgba(0,0,0,0.23)',
                                        borderRadius: '4px',
                                        p: '10px 14px',
                                        maxHeight: 150,
                                        overflowY: 'auto',
                                        fontSize: 14,
                                        lineHeight: 1.6,
                                        color: 'rgba(0,0,0,0.6)',
                                        backgroundColor: 'rgba(0,0,0,0.04)',
                                        '& table': { borderCollapse: 'collapse', width: '100%' },
                                        '& td, & th': { border: '1px solid #ddd', padding: '4px 8px' },
                                    }}
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(latestRecord.note || '') }}
                                />
                            </Box>
                            <TextFiledWithLabel
                                disabled
                                type="date"
                                value={latestRecord.date ? moment(latestRecord.date).format('YYYY-MM-DD') : ''}
                                label={latestDateLabel}
                                sx={{ width: 220 }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </StyledLeadContainer>
                    </Box>
                )}
                {!readOnly && (
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: 'text.secondary' }}>
                            {newRecordTitle}
                        </Typography>
                        <StyledLeadContainer>
                            <TextFiledWithLabel
                                autoFocus
                                id={`actionable-note-${newNoteName}`}
                                label={newNoteLabel}
                                required={true}
                                name={newNoteName}
                                value={newNoteValue || ''}
                                handleOnChange={handleOnChange}
                                error={noteError}
                                style={{ width: '59%' }}
                            />
                            <TextFiledWithLabel
                                id={`actionable-date-${newDateName}`}
                                type="date"
                                name={newDateName}
                                value={newDateValue || ''}
                                label={newDateLabel}
                                handleOnChange={handleOnChange}
                                sx={{ width: 220 }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </StyledLeadContainer>
                    </Box>
                )}
            </Box>
        </LeadDialog>
    );
};

export default AddActionableNoteDialog;
